import axios from "axios";
import { SERVER_URL } from "./constants";
import { REFRESH_USER_PATH, USER_PATH } from "./UsersApi/UsersApi";
import { setUserAfterRefreshAxios } from "AppStore/Slices/UserSlice/UserSlice";
import { getTelegramInitData } from "./TelegramApi/telegram";

let reduxStore = null;
export const injectStore = (_store) => {
  reduxStore = _store;
};

const $apiPrivate = axios.create({
  baseURL: SERVER_URL,
  withCredentials: true,
});
const $apiPublic = axios.create({
  baseURL: SERVER_URL,
  withCredentials: true,
});
const $apiTelegram = axios.create({
  baseURL: SERVER_URL,
});

$apiPrivate.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("accessTokenPA");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

$apiPrivate.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      originalRequest.url !== "/users/refresh"
    ) {
      originalRequest._retry = true; // Mark request as retried

      try {
        const data = await $apiPublic.get(USER_PATH + REFRESH_USER_PATH);
        const { accessToken, user } = data.dto;
        const newAccessToken = accessToken;

        if (reduxStore) {
          reduxStore.dispatch(setUserAfterRefreshAxios(user));
        }

        // 2. Оновлюємо токен рефреш
        localStorage.setItem("accessTokenPA", newAccessToken);
        // axios.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
        // originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;

        // 3. Повторюємо оригінальний запит
        return $apiPrivate(originalRequest);
      } catch (e) {
        window.location.href = "/user/login";
        return e?.response?.data || "Непередбачена помилка";
      }
    }

    return error?.response?.data;
  },
);

$apiPublic.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error) {
    return error?.response?.data || Promise.reject(error);
  },
);

$apiTelegram.interceptors.request.use(
  (config) => {
    // const tg = getTelegram();

    // const initData = tg?.initData;
    const initData = getTelegramInitData();

    if (initData) {
      config.headers["X-Telegram-Init-Data"] = initData;
    }

    config.headers["ngrok-skip-browser-warning"] = "true";

    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

$apiTelegram.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error) {
    return error?.response?.data || Promise.reject(error);
  },
);

export { $apiPrivate, $apiPublic, $apiTelegram };
